import * as React from "react"
import type { SVGProps } from "react"
const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.45 16.07q.6.6 1.55.59.95 0 1.4-.69l4.22-6.32q.23-.36-.06-.64-.29-.3-.63-.06l-6.33 4.22q-.68.45-.71 1.38-.04.92.56 1.52M12 4.57q.9 0 1.78.15.87.15 1.7.48.39.14.84.56.45.41.25.79c-.2.38-.43.41-.9.5q-.7.12-1.12-.03A7 7 0 0 0 12 6.57q-3.32 0-5.66 2.34A7.7 7.7 0 0 0 4 14.57a7.7 7.7 0 0 0 1.1 4h13.8a7 7 0 0 0 .84-1.97 9 9 0 0 0 .26-2.13 7 7 0 0 0-.45-2.5 1.4 1.4 0 0 1-.05-.82q.1-.4.45-.68a.8.8 0 0 1 .71-.15.8.8 0 0 1 .54.45 10 10 0 0 1 .8 3.65 10 10 0 0 1-.32 2.73 10 10 0 0 1-1.03 2.47q-.27.45-.75.7t-1 .25H5.1q-.52 0-1-.25a2 2 0 0 1-.75-.7A10 10 0 0 1 2 14.57q0-2.07.79-3.89a10 10 0 0 1 2.15-3.17 10 10 0 0 1 3.19-2.15A10 10 0 0 1 12 4.57" />
  </svg>
)
export default SvgDashboard
